import { TS_Flight }             from '../TravelSeller/Models/TS_Flight';
import { BookingItemInterface } from './BookingItemInterface';

export class Flight extends TS_Flight implements BookingItemInterface {}